/**
 * @generated SignedSource<<512abe905bb137eb2096312649938e04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ActivitySource = "CABANA" | "SIPGATE" | "STRIPE" | "ZAMMAD" | "%future added value";
export type CustomerActivityViewLoadMoreQuery$variables = {
  customerAccountIdentifier: string;
  first?: number | null | undefined;
  offset?: number | null | undefined;
};
export type CustomerActivityViewLoadMoreQuery$data = {
  readonly customerAccountActivities: {
    readonly activities: ReadonlyArray<{
      readonly actorName: string | null | undefined;
      readonly body: string | null | undefined;
      readonly id: string;
      readonly metadata: any;
      readonly occurredAt: any;
      readonly source: ActivitySource;
      readonly type: string;
    }>;
    readonly hasMore: boolean;
  };
};
export type CustomerActivityViewLoadMoreQuery = {
  response: CustomerActivityViewLoadMoreQuery$data;
  variables: CustomerActivityViewLoadMoreQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "customerAccountIdentifier"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerAccountIdentifier",
        "variableName": "customerAccountIdentifier"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "ActivityResult",
    "kind": "LinkedField",
    "name": "customerAccountActivities",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Activity",
        "kind": "LinkedField",
        "name": "activities",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "source",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "occurredAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metadata",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actorName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasMore",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CustomerActivityViewLoadMoreQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CustomerActivityViewLoadMoreQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c4d1629de9c06ea992a4a99264e35826",
    "id": null,
    "metadata": {},
    "name": "CustomerActivityViewLoadMoreQuery",
    "operationKind": "query",
    "text": "query CustomerActivityViewLoadMoreQuery(\n  $customerAccountIdentifier: ID!\n  $first: Int\n  $offset: Int\n) {\n  customerAccountActivities(customerAccountIdentifier: $customerAccountIdentifier, first: $first, offset: $offset) {\n    activities {\n      id\n      source\n      type\n      occurredAt\n      metadata\n      actorName\n      body\n    }\n    hasMore\n  }\n}\n"
  }
};
})();

(node as any).hash = "05c4785484f7ed5da0645d3d3ebd37ba";

export default node;
